import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const Medal = (props) => (
    <svg
        fill='none'
        height='32'
        viewBox='0 0 30 32'
        width='30'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M5.26378 17.5612C4.77124 18.7775 4.5 20.1071 4.5 21.5C4.5 27.299 9.20101 32 15 32C20.799 32 25.5 27.299 25.5 21.5C25.5 20.1058 25.2283 18.7751 24.7349 17.558L29.0463 13.2531C29.6569 12.6435 30 11.8161 30 10.9533V3.25C30 1.45507 28.5449 0 26.75 0H3.25C1.45507 0 0 1.45507 0 3.25V11.1729C0 12.0648 0.366556 12.9175 1.01377 13.5312L5.26378 17.5612ZM3.25 2.5H26.75C27.0166 2.5 27.2506 2.63906 27.3836 2.84858L24.2322 6H5.76777L2.61635 2.84859C2.74937 2.63906 2.98344 2.5 3.25 2.5ZM11.4008 11.6331L8.26777 8.5H21.7322L18.5992 11.6331C17.4765 11.2235 16.2644 11 15 11C13.7356 11 12.5235 11.2235 11.4008 11.6331ZM9.06754 12.8353C8.08493 13.5094 7.22275 14.3462 6.5199 15.307L2.73395 11.7171C2.58459 11.5755 2.5 11.3787 2.5 11.1729V6.26777L9.06754 12.8353ZM23.4678 15.2903C22.7672 14.3365 21.9094 13.5055 20.9325 12.8353L27.5 6.26777V10.9533C27.5 11.1524 27.4208 11.3433 27.2799 11.484L23.4678 15.2903ZM7 21.5C7 17.0817 10.5817 13.5 15 13.5C19.4183 13.5 23 17.0817 23 21.5C23 25.9183 19.4183 29.5 15 29.5C10.5817 29.5 7 25.9183 7 21.5Z'
            fill='currentColor'/>
    </svg>
);

export default Medal;
